import React from 'react';
import { connect } from 'react-redux';
import { notify, fetchSubscriptionSuccess, reactivateSubscriptionSuccess, push } from 'actions';
import { SubscriptionDetails, Container, LoadingSpinner, IconBox } from 'components';
import { fetchFeaturePlans, fetchPlans, fetchSubscriptions, reactivateSubscription } from 'api';
import { Button, Row, Col } from 'react-bootstrap';

class SubscriptionDetailsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching_data: true,
      error_reactivating: false,
      plans: [],
      map_regions: [],
      monthly_items: [],
      yearly_items: []
    };

    this.handleClickNewSubscription = this.handleClickNewSubscription.bind(this);
    this.handleClickUpdateSubscription = this.handleClickUpdateSubscription.bind(this);
    this.handleClickReactivateSubscription = this.handleClickReactivateSubscription.bind(this);

    this.mounted = false;
  }

  handleClickNewSubscription() {
    this.props.push('/settings/subscriptions/wizard');
  }
  handleClickUpdateSubscription() {
    this.props.push({
      pathname: '/settings/subscriptions/wizard',
      state: { subscriptions: this.props.subscriptions.subscriptions }
    });
  }
  handleClickReactivateSubscription() {
    const { subscriptions } = this.props.subscriptions;
    const cancelled_subscriptions = subscriptions.filter(s => s.status == 'cancelled');
    this.setState({ fetching_data: true });
    Promise.all(cancelled_subscriptions.map(s => reactivateSubscription(s._id)))
    .then(() => {
      this.props.reactivateSubscriptionSuccess();
      this.props.notify({ title: 'Success', message: 'Subscription reactivated successfully' }, { type: 'success' });
      this.setState({ fetching_data: false });
    })
    .catch(e => {
      console.log(e);
      this.setState({
        fetching_data: false,
        error_reactivating: true
      });
    });
  }
  componentWillMount() {
    const { users, subscriptions } = this.props;
    (() => {
      if(subscriptions.subscriptions.length == 0) {
        const { user } = users;
        const fetch_options = { filters: { account: user.owner_account || user._id } };
        return fetchSubscriptions(fetch_options).then(({ results }) => this.props.fetchSubscriptionSuccess(results));
      }
      else {
        return Promise.resolve();
      }
    })()
    .then(() => {
      Promise.all([
        fetchPlans(),
        fetchFeaturePlans()
      ])
      .then(([ { results: plans }, map_regions ]) => {
        if(this.mounted) {
          let monthly_items = [], yearly_items = [];
          this.props.subscriptions.subscriptions.forEach(subscription => {
            const { items } = subscription;
            items.forEach(item => {
              const current_plan = plans.find(p => p._id == item.plan);
              if(current_plan.interval == 'month') {
                monthly_items.push(item);
              }
              else {
                yearly_items.push(item);
              }
            });
          })
          this.setState({
            plans,
            map_regions,
            monthly_items,
            yearly_items,
            fetching_data: false
          });
        }
      });
    })
    .catch(e => {
      console.log(e);
      this.props.notify(e);
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { subscriptions } = this.props.subscriptions;
    const CustomComponent = subscriptions.length == 0 ? (
      <Button onClick={this.handleClickNewSubscription}>
        Create Subscription
      </Button>
    ) : (
      <div>
        <SubscriptionDetails
          plans={this.state.plans}
          map_regions={this.state.map_regions}
          subscriptions={subscriptions}
          monthly_items={this.state.monthly_items}
          yearly_items={this.state.yearly_items}
        />
        <Row>
          <Col md={12} xs={12}>
            <Button block bsStyle='primary' onClick={this.handleClickUpdateSubscription}>
              <p><span style={{ marginRight: '15px' }}><i className='fa fa-pencil' /></span>Update Subscription</p>
            </Button>
          </Col>
        </Row>
      </div>
    );

    const title = subscriptions.length == 0 ? (
      'No Subscriptions'
    ) : subscriptions.length == 1 ? (
      'Current Plan'
    ) : (
      'Current Plans'
    );
    return (
      <div className='subscription-details-view-container'>
        <Container title='Subscription Details'>
          {this.state.fetching_data ? (
            <LoadingSpinner />
          ) : subscriptions.find(s => s.status == 'cancelled') ? (
            <p>
              At least one of your subscriptions has been canclled due to late payment.
              <a onClick={this.handleClickReactivateSubscription}> Click Here </a>
              to reactivate your subscription
            </p>
          ) : this.state.error_reactivating ? (
            <p>There was an error reactivating your subscription. Update your payment method and try again</p>
          ) : (
            <IconBox CustomComponent={CustomComponent} />
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ subscriptions, users }) => ({ subscriptions, users });

export default connect(mapStateToProps, { notify, fetchSubscriptionSuccess, reactivateSubscriptionSuccess, push })(SubscriptionDetailsView);



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/subscription-details-view.js